import * as apm from '@oysterjs/core/apm';
import { query } from '@oysterjs/core/graphql/loaders';
import { client } from './client';
import {
  AccountFieldsFragment,
  AccountUserFieldsFragment,
  BusinessPolicyFieldsFragment,
  GetAccountDocument,
  GetAccountQuery,
  GetAccountQueryVariables,
  GetAccountUserDocument,
  GetAccountUserQuery,
  GetAccountUserQueryVariables,
  GetAccountsDocument,
  GetAccountsQuery,
  GetAccountsQueryVariables,
  GetBusinessPolicyDocument,
  GetBusinessPolicyQuery,
  GetBusinessPolicyQueryVariables,
  CreateCertificateOptionsFieldsFragment,
  GetCreateCertificateOptionsQueryVariables,
  GetCreateCertificateOptionsDocument,
  GetCreateCertificateOptionsQuery,
  ServiceRequestFieldsFragment,
  GetServiceRequestDocument,
  GetServiceRequestQuery,
  GetServiceRequestQueryVariables
} from './graphql';

export const getAccountUser = async () =>
  query<GetAccountUserQuery, GetAccountUserQueryVariables, AccountUserFieldsFragment>(
    client,
    { query: GetAccountUserDocument },
    async (data) => {
      if (data.accountUser) {
        apm.setUser({
          id: data.accountUser.id,
          email: data.accountUser.email,
          name: data.accountUser.name,
          accountId: data.accountUser.accounts?.[0]?.id,
          accountName: data.accountUser.accounts?.[0]?.account.name
        });
      }
      return data.accountUser;
    }
  );

export const getAccounts = async () =>
  query<GetAccountsQuery, GetAccountsQueryVariables, AccountFieldsFragment[]>(
    client,
    { query: GetAccountsDocument },
    (data) => data.accounts
  );

export const getAccount = async () =>
  query<GetAccountQuery, GetAccountQueryVariables, AccountFieldsFragment>(
    client,
    {
      query: GetAccountDocument,
      variables: { id: window.sessionStorage.getItem('_accountid') || '' }
    },
    (data) => data.account,
    { notFoundRedirect: '/' }
  );

export const getPolicy = async ({ params }) =>
  query<GetBusinessPolicyQuery, GetBusinessPolicyQueryVariables, BusinessPolicyFieldsFragment>(
    client,
    {
      query: GetBusinessPolicyDocument,
      variables: { id: params.id || '' }
    },
    (data) => data.businessPolicy,
    { notFoundRedirect: '/' }
  );

export const getCreateCertificateOptions = async () =>
  query<
    GetCreateCertificateOptionsQuery,
    GetCreateCertificateOptionsQueryVariables,
    CreateCertificateOptionsFieldsFragment
  >(
    client,
    {
      query: GetCreateCertificateOptionsDocument,
      variables: { accountId: window.sessionStorage.getItem('_accountid') || '' }
    },
    (data) => data.createCertificateOptions
  );

export const getServiceRequest = async ({ params }) =>
  query<GetServiceRequestQuery, GetServiceRequestQueryVariables, ServiceRequestFieldsFragment>(
    client,
    { query: GetServiceRequestDocument, variables: { id: params.id || '' } },
    (data) => data.serviceRequest
  );
